import { addAuthorizationToHeader } from "./authorize";
import { BASE_PATH } from "./base";
const UPDATE_RESOURCE_PATH = BASE_PATH + "/update-resource";
export const updateResource = async (resource) => {
    const headers = new Headers();
    addAuthorizationToHeader(headers);
    headers.set("Content-Type", "application/json");
    return fetch(UPDATE_RESOURCE_PATH, {
        method: "POST",
        headers,
        body: JSON.stringify(resource),
    }).then((response) => response.json());
};
